import { Component, inject } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: 'app-not-qualified',
  standalone: false,
  templateUrl: './not-qualified.component.html',
  styleUrl: '../../../assets/css/HighLimitsDialogs.css'
})
export class NotQualifiedComponent {
  readonly dialogRef = inject(MatDialogRef<NotQualifiedComponent>);

  constructor() {
  }

  close() {
    this.dialogRef.close(false);
  }
}
